import { PathOptions } from "leaflet";

export const ufv_expansao_planejada = (feature: any): PathOptions => {
  return {
    color: "#FFD700",
    weight: 2,
    opacity: 0.8,
    fillColor: "#FFA500",
    fillOpacity: 0.4,
  };
};
